// "Add reel": paste an Instagram link, or share it to @eat.recipe in Instagram.
import { useEffect, useRef, useState } from 'preact/hooks';
import { api, ApiError } from '../api';
import { Chat } from '../icons';
import { useT } from '../i18n';

export function AddReelSheet({ onClose, onAdded }: { onClose: () => void; onAdded: () => void }) {
  const t = useT();
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const input = useRef<HTMLInputElement>(null);
  useEffect(() => {
    input.current?.focus();
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, []);
  const submit = async (e: Event) => {
    e.preventDefault();
    if (!url.trim()) return;
    setBusy(true);
    setErr('');
    try {
      await api.addReel(url.trim());
      onAdded();
    } catch (ex) {
      setErr((ex as ApiError).message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div class="scrim" role="dialog" aria-modal="true" aria-labelledby="add-title" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <form class="sheet" onSubmit={submit}>
        <div class="sheet-handle" aria-hidden="true" />
        <h2 id="add-title" class="h2">{t('add.title')}</h2>
        <label for="reel-url" class="muted" style="font-size:14px">{t('add.label')}</label>
        <input id="reel-url" ref={input} class="input" type="url" inputMode="url" autoComplete="off"
          placeholder="https://www.instagram.com/reel/…" value={url} onInput={(e) => setUrl((e.target as HTMLInputElement).value)} />
        {err && <div class="error-text" role="alert">{err}</div>}
        <button class="btn btn-primary" type="submit" disabled={busy || !url.trim()}>{busy ? t('add.adding') : t('add.submit')}</button>
        <div class="muted" style="text-align:center;font-size:14px">{t('add.or')}</div>
        <a class="btn btn-outline" href="https://ig.me/m/eat.recipe"><Chat />@eat.recipe</a>
        <button type="button" class="btn-text" onClick={onClose}>{t('common.cancel')}</button>
      </form>
    </div>
  );
}
